<script setup>
import { IdentificationIcon } from '@heroicons/vue/24/outline'
import HeadingOne from '@/Components/HeadingOne.vue'
import Paragraph from '@/Components/Paragraph.vue'
import axios from 'axios'

defineProps({
    product_price: {
        type: Number,
        required: true,
    },
})
</script>

<template>
    <div class="relative isolate overflow-hidden lg:min-h-screen">
        <svg
            class="absolute inset-0 -z-10 size-full [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)] stroke-zinc-200 dark:stroke-zinc-800"
            aria-hidden="true"
        >
            <defs>
                <pattern
                    id="0787a7c5-978c-4f66-83c7-11c213f99cb7"
                    width="200"
                    height="200"
                    x="50%"
                    y="-1"
                    patternUnits="userSpaceOnUse"
                >
                    <path
                        d="M.5 200V.5H200"
                        fill="none"
                    />
                </pattern>
            </defs>
            <rect
                width="100%"
                height="100%"
                stroke-width="0"
                fill="url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
            />
        </svg>
        <div class="section--width">
            <div class="flex flex-col items-center justify-center space-y-10 lg:space-y-0 xl:flex-row xl:justify-between">
                <div class="m-auto max-w-2xl lg:mx-0 lg:shrink-0 xl:max-w-3xl">
                    <div class="mt-0 inline-flex w-full items-center justify-center sm:mt-32 lg:mt-16">
                        <div
                            class="rounded-full bg-cyan-400/20 px-3 py-1 text-center ring-1 ring-cyan-400/20 ring-inset dark:bg-cyan-600/20 dark:ring-cyan-600/20"
                        >
                            <Link
                                :href="route('orders.create')"
                                aria-label="Podat daňové přiznání za rok {{ new Date().getFullYear() - 1 }}"
                                class="text-sm/6 font-semibold text-cyan-700 dark:text-cyan-600"
                            >
                                <span> Podat daňové přiznání za rok {{ new Date().getFullYear() - 1 }} - </span>

                                <span class="animate-pulse text-black dark:text-white"> jen za {{ product_price }} Kč </span>
                            </Link>
                        </div>
                    </div>

                    <HeadingOne value="Daňové přiznání snadno a rychle" />

                    <Paragraph
                        classes="text-center"
                        value="Už vás nebaví stres z daňového přiznání? Tady je řešení, které vám zachrání čas, nervy i peníze!"
                    />

                    <div class="relative mt-10 flex items-center justify-center divide-x overflow-hidden xl:justify-center">
                        <Link
                            :href="route('orders.create')"
                            class="relative flex items-center rounded-lg border border-cyan-500 bg-cyan-400 px-4 py-2 dark:border-cyan-300 dark:bg-cyan-600"
                        >
                            <IdentificationIcon class="mr-2 size-5 text-white sm:size-7" />

                            <span class="text-sm font-medium text-white transition-colors duration-200 sm:text-base">
                                Podat přiznání za rok 2024
                            </span>
                        </Link>
                    </div>
                </div>

                <div class="-m-2 rounded-xl p-2 lg:-m-4 lg:rounded-2xl lg:p-4">
                    <img
                        src="src/hero/file.png"
                        alt="App screenshot"
                        class="h-[20rem] xl:h-[40rem]"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
